import { ApiError } from '@/shared/api/api-client';

/**
 * The server's own message for a failed cohort call (pattern from pm-react #1242): 400 field
 * errors joined, else the ProblemDetails `detail` / `title`, else the body text.
 */
export function serverMessage(err: unknown): string {
  if (!(err instanceof ApiError)) return err instanceof Error ? err.message : String(err);
  const body = err.body.trim();
  if (!body) return err.message;
  try {
    const parsed = JSON.parse(body) as {
      errors?: Record<string, string[]>;
      detail?: string;
      title?: string;
      message?: string;
    };
    const fields = parsed.errors ? Object.values(parsed.errors).flat() : [];
    if (err.status === 400 && fields.length) return fields.join(' ');
    return parsed.detail ?? parsed.title ?? parsed.message ?? body;
  } catch {
    return body;
  }
}

/** 409 on a single enrol = the patient already has an overlapping membership in this cohort. */
export function isOverlapConflict(err: unknown): boolean {
  return err instanceof ApiError && err.status === 409;
}
